import React, { useContext, useEffect } from "react"
import { useParams, useSearchParams } from "react-router-dom"
import Player from "../../../components/player/player"
import { programmeContext, programmeNameContext, domain } from "../../../contexts"
import { useState } from "react"
import SvgIcon from "../../../components/svg/svg"

const Temoin = ({ loadHdForFrame, currentFloor, interactivTemoin }) => {

  // Functions
  const getTemoin = (list, value) => {
    return (
      list.find(elem => elem.urlName === value) ||
      list[0]
    )
  }

  // Properties
  const { currentInt } = useParams()
  const [searchParams] = useSearchParams()
  const programmeName = useContext(programmeNameContext)
  const programmeDatas = useContext(programmeContext)
  const temoinsDatas = programmeDatas.pagesDetails.interieurs2.temoins
  const currentTemoinFolder = getTemoin(temoinsDatas, currentInt)
  const nbFrame = currentTemoinFolder.nbFrame
  const getCurrentInteractive = () => {
    if (currentFloor === "etage0") return currentTemoinFolder.interactiv0
    if (currentFloor === "etage1") return currentTemoinFolder.interactiv1
    if (currentFloor === "etage2") return currentTemoinFolder.interactiv2
  }

  const [decalX, setDecalX] = useState(0)
  const [decalY, setDecalY] = useState(0)

  const [powerX, setPowerX] = useState(0)
  const [powerY, setPowerY] = useState(0)
  const [poiDisplay, setPoiDisplay] = useState('none')

  const [selectedPoi, setSelectedPoi] = useState(-1)


  // Fonctions 
  const detectRatio = () => { // Fonction de detection des ratios

    const wx = document.getElementById('interactivTemoin').clientWidth;
    const wy = document.getElementById('interactivTemoin').clientHeight;
    const image = document.querySelector("#bckImg");

    const windowRatio = wx / wy;

    const getMeta = (url, callback) => {

      const img = new Image();
      img.src = url;
      img.onload = function () {
        callback(this.width, this.height);
      }
    }
    getMeta(
      image.src,
      (width, height) => {
        if (windowRatio < width / height) {
          image.style.width = 'auto';
          image.style.height = '100%';
        } else {
          image.style.width = '100%';
          image.style.height = 'auto';
        }
      }
    )
  }

  useEffect(() => {
    setSelectedPoi(-1)
  }, [currentInt])

  useEffect(() => {
    setPoiDisplay("none");
    setSelectedPoi(-1)

    setTimeout(() => { setPoiDisplay("flex") }, 25)
  }, [interactivTemoin, currentFloor])

  useEffect(() => {
    if (!interactivTemoin) { return }

    const checkPoi = () => {

      detectRatio()

      setTimeout(() => {
        const canvas = document.getElementById("interactivTemoin")
        const img = document.getElementById("bckImg")

        setDecalX(canvas.offsetWidth / 2)
        setDecalY(canvas.offsetHeight / 2)

        setPowerX(img.offsetWidth)
        setPowerY(img.offsetHeight)
      }, 200)
    }


    const handleSize = () => {
      checkPoi();
    }
    window.addEventListener('resize', handleSize);
    checkPoi();

    return (() => {
      window.removeEventListener('resize', handleSize);
    })
  }, [interactivTemoin])

  // render
  if (interactivTemoin) {
    return <div id="interactivTemoin" className={(searchParams.get("isolate") || searchParams.get("noheader")) ? (currentTemoinFolder.interactiv0 && currentTemoinFolder.nbFrame !== 0) ? "isolate" : "superisolate" : "normal"} onClick={() => setSelectedPoi(-1)}>
      <img id="bckImg" src={`${domain}/static/${getCurrentInteractive()}`} />

      <div id="interactivPois">
        {currentTemoinFolder.pois.filter(x => x.floor === currentFloor).map((poi, i) =>
          <div className="interactivPoi" style={{
            display: poiDisplay,
            left: decalX + ((poi.x - 50) * powerX / 100),
            top: decalY + ((poi.y - 50) * powerY / 100),
          }} onClick={e => { e.stopPropagation(); setSelectedPoi(i) }}>
            <div style={{ backgroundColor: poi.color }}></div>
            <span>{poi.title}</span>
          </div>
        )}
      </div>

      {selectedPoi !== -1 && currentTemoinFolder?.pois[selectedPoi]?.infoTitle && <div id="bulleInfoContainer" className={(searchParams.get("isolate") || searchParams.get("noheader")) ? currentTemoinFolder.typeOf !== "simplex" ? "" : "decal" : currentTemoinFolder.typeOf !== "simplex" ? "undecal" : ""} >
        <div id="bulleInfo" onClick={e => e.stopPropagation()}>
          {currentTemoinFolder.pois[selectedPoi].infoImage &&
            <div id="imgContainer">
              <img id='imgBulle' src={`${domain}/static/${currentTemoinFolder.pois[selectedPoi].infoImage}`} />
            </div>
          }
          <div id="bulleInfoContent">
            <div className="mainColor">{currentTemoinFolder.pois[selectedPoi].infoTitle}</div>
            <div className="subColor">{currentTemoinFolder.pois[selectedPoi].infoSubtitle}</div>
              {currentTemoinFolder.pois[selectedPoi].infoText &&
              <div id="bulleDescription">{currentTemoinFolder.pois[selectedPoi].infoText}</div>
              }

              {currentTemoinFolder.pois[selectedPoi].infoUrl &&
              <div id="bulleUrlContainer">
                <div id="bulleUrl">
                  <a target="_blank" href={currentTemoinFolder.pois[selectedPoi].infoUrl}>
                    {currentTemoinFolder.pois[selectedPoi].infoUrlDisplay}
                    <SvgIcon icon={"fleche-r"} />
                  </a>
                </div>
              </div>
              }
          </div>
        </div>
      </div>}
    </div>
  } else {
    return (
      <Player
        programme={programmeName}
        navUrl={`temoins/${currentTemoinFolder.id}/${currentFloor}`}
        type="interieurs2"
        numFrames={nbFrame}
        start={0}
        maxResolution={1080}
        loadHdForFrame={loadHdForFrame}
      />
    )
  }
}

export default Temoin
